import { actionType } from '../actions/product';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function product(state = initState, action) {
  state.params.status = 'ALL';
  switch (action.type) {
    default:
      return baseReducer(state, action, actionType);
  }
}
